import { Grid, Typography } from "@mui/material";
import { SpeedBoostButton } from "../GameButtons";
import { Producer } from "../../types/game";
import { TabHeader } from "./TabHeader";
import { GameContext } from "../../provider/GameProvider";
import { useContext } from "react";

export default function SpeedShopTab({}: {}) {
  const { game } = useContext(GameContext);
  return (
    <div>
      <Grid container spacing={2}>
        <TabHeader />
        <Grid item md={12} xs={12} style={{}}>
          <Typography
            variant="h5"
            style={{
              color: "lightblue",
              textAlign: "center",
              paddingBottom: 32,
            }}
          >
            Speed-Shop
          </Typography>
        </Grid>
        {game.producers.map((producer, index) => {
          if (index === 0) return null;
          return (
            <Grid item xs={4}>
              <SpeedBoostButton index={index} />
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}
